import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export default function AuthErrorPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const { error, details } = location.state || {
    error: 'An unexpected error occurred',
    details: null
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <h1 className="text-2xl font-bold mb-4">Authentication Error</h1>
      <p className="text-muted-foreground mb-2">{error}</p>
      {details && (
        <p className="text-sm text-muted-foreground mb-4">{details}</p>
      )}
      <div className="space-x-4">
        <Button onClick={() => navigate('/onboarding/register-options')}>
          Try Again
        </Button>
        <Button variant="outline" onClick={() => navigate('/')}>
          Go Home
        </Button>
      </div>
    </div>
  )
} 